import { InputPanelHeader } from "./InputPanelHeader";
import { InputFields } from "./InputFields";
import { Panel } from "../types";
import { Box } from "@mui/material";

interface Props {
  setPanel: (panel: Exclude<Panel, "None" | "Constraints">) => void;
}

export const InputPanel = ({ setPanel }: Props) => {
  return (
    <Box
      sx={{
        height: "100%",
        borderRight: 1,
        overflowY: "auto",
      }}
    >
      <Box sx={{ pt: 4 }}>
        <InputPanelHeader />
        <InputFields setPanel={setPanel} />
      </Box>
    </Box>
  );
};
